import type { ComponentOverrides } from 'theme/theme.types';

export const MuiFormControlLabel: ComponentOverrides['MuiFormControlLabel'] = {
  styleOverrides: {
    root: {
      marginLeft: 0,
      marginRight: 0,
    },
    label: ({ theme }) => ({
      color: theme.palette.text.primary,
      '&.Mui-disabled': {
        color: theme.palette.text.disabled,
      },
    }),
  },
};
